import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
    BaseQueryFn,
    FetchArgs,
    FetchBaseQueryError,
} from "@reduxjs/toolkit/query"; 

import { fetchAuthSession, signOut } from "aws-amplify/auth";
import {
    broadcastLogoutEvent,
    clearAuthSessionData,
} from "../auth/sessionStorage";

const baseURL = import.meta.env.VITE_API_ENDPOINT_ROOT;

const rawBaseQuery = fetchBaseQuery({
    baseUrl: baseURL,
    credentials: "include",
    prepareHeaders: async (headers) => {
        try {
            const session = await fetchAuthSession();
            const token = session.tokens?.accessToken?.toString();

            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
        } catch {
            // Not authenticated
        }

        return headers;
    },
});

export const customBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error?.status === 401) {
        try {
            await signOut();
        } catch {
            // no-op: still clear local auth state and redirect
        } finally {
            clearAuthSessionData();
            broadcastLogoutEvent();
        }

        window.location.replace("/login");
    }

    return result;
};